import { useSelector } from 'react-redux';

import './spinner.scss';

const Spinner = () => {
  const { spinners } = useSelector(({ system }) => system);

  if (!spinners || spinners.length === 0) return null;

  return (
    <div className="spinner">
      <p>{spinners.at(-1)}...</p>
      <div className="spinner__ellipsis">
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default Spinner;
